export const HIDDEN = "••••••";

export const display = (v) => {
  if (v === null || v === undefined) return "";
  if (typeof v === "object") return JSON.stringify(v);
  return String(v);
};

// Convert edited text back to the type of the original value
export function parseLike(text, original) {
  if (typeof original === "number") {
    const n = Number(text.replace(",", "."));
    if (Number.isNaN(n)) throw new Error("Valore numerico non valido");
    return n;
  }
  if (typeof original === "boolean") return text.trim().toLowerCase() === "true";
  if (original !== null && typeof original === "object") return JSON.parse(text);
  return text;
}

// Infer type for new values (numbers, booleans, JSON objects/arrays, otherwise string)
export function parseAuto(text) {
  const t = text.trim();
  if (t === "") return "";
  if (t === "true" || t === "false") return t === "true";
  if (/^-?\d+(\.\d+)?$/.test(t)) return Number(t);
  if (t.startsWith("{") || t.startsWith("[")) {
    try { return JSON.parse(t); } catch { return text; }
  }
  return text;
}
